let locales = {
    editNoteModal_chekbox: `Selecciona para crear un recordatorio por Email`,
    editNoteModal_date: `Fecha`,
    editNoteModal_hour: `Hora`,
}

export default locales;